<template>
  <div class="page1">
    <header class="nav-warp ica">
      <div>
        <app-header />
        <!-- <a class="nav-logo" href="/"><img src="../assets/img/wz_logo.png" /></a>
        <div class="nav-menu">
          <router-link to="/">首页</router-link>
          <router-link to="/tech">技术介绍</router-link>
          <router-link to="/product">产品与服务</router-link>
          <router-link to="/healthy">AI认知大脑</router-link>
          <a href="http://wz.wuzhengai.com" target="_blank">防疫物资</a>
          <router-link to="/about">关于我们</router-link>
        </div>
        <div class="nav-signup">
          <div class="nav-login" style="display:none;">
            <a href="javascript:void(0);" @click="login">登录</a>
            <a href="javascript:void(0);" @click="register">注册</a>
          </div>
          <div class="nav-signout" style="display:;">
            <a href="#"><img src="../assets/img/user.jpg">用户中心</a>
            <a href="#"><i></i>退出</a>
          </div>
        </div> -->
      </div>
    </header>
    <div class="" style="min-height:750px;margin-top: 150px;">
      <!-- =====STEP===== -->
      <div class="sympwrap">
        <div class="symp-w stepwrap">
          <ul class="symp-step">
            <li class="active">
              <!-- finish -->
              <i></i>
              <em>表征选择</em>
            </li>
            <li v-bind:class="{active: isTwo}">
              <i></i>
              <em>描述症状</em>
            </li>
            <li v-bind:class="{active: isThree}">
              <i></i>
              <em>症状摘取</em>
            </li>
            <li v-bind:class="{active: isFour}">
              <i></i>
              <em>选择算法</em>
            </li>
            <li v-bind:class="{active: isFive}">
              <i></i>
              <em>生成报告</em>
            </li>
          </ul>
        </div>
      </div>
      <div class="sympwrap">
        <!-- 步骤1 -->
        <div class="symp-w" v-if="showOne">
          <div class="symp-tit">选择您想诊断的表征信息</div>
          <ul class="symp-opt">
            <li v-for="(item, index) in selfTestTypeList" :key="index">
              <a href="javascript:void(0);" @click="nextTwo(item)">
                <svg>
                  <rect x="0" y="0" fill="none" width="100%" height="100%"></rect>
                </svg>
                {{item.name}}
              </a>
            </li>
          </ul>
        </div>
        <!-- 步骤2 -->
        <div class="symp-w" v-if="showTwo">
          <div class="symp-tit">请描述您的症状信息</div>
          <div class="desc-set">
            <div><span>您选择的表征</span><em>{{typeName}}</em></div>
          </div>
          <div class="desc-warp zclear">
            <div class="desc-listtit">信息阐述</div>
            <div class="desc-list">
              <!-- <form> -->
              <div class="desc-txtarea">
                <div>
                  <textarea placeholder="请尽量准确的阐述您的症状信息..." maxlength="50" @input="descInput" v-model="desc" />
                  <span class="numberV">{{txtVal}}/50</span>



                </div>



              </div>
                 <div style="clear: both;"></div>
                 <div class="input-tips" v-if="accessToScripts.length>0">
                    <p>与“{{typeName}}”相关的话述</p>
                    <div class="tips_wrap">
                      <ul>
                         <li v-for="val in accessToScripts" @click="leaveyou(val)">{{val}}</li>
                      </ul>
                    </div>
                  </div>
              <div class="desc-butt" style='position: relative;left: auto;bottom: auto;margin-top: 20px;float: left;'>
                  <button type="button" @click="nextThree">信息提交</button>
                  <a href="javascript:void(0);" @click="go">重新选择</a>
                </div>
              <!-- </form> -->
            </div>
          </div>
        </div>
        <!-- 步骤3 -->
        <div class="symp-w" v-if="showThree">
          <div class="symp-tit">症状描述</div>
          <div class="pick-des">{{desc}}</div>
          <div class="pick-analysis">
            <div class="loading-warp" v-if="transferMesShow">
              <div id="loading">
                <div class="outer"></div>
                <div class="inner"></div>
              </div>
              <p>分析中</p>
            </div>
            <div class="analysis">
              <em>解析结果</em>
              <div class="analysis-list">
                <span v-for="(item, index) in participle" :key="index">{{item}}</span>
              </div>
            </div>
          </div>
          <div class="pick-analysis">
            <div class="loading-warp" v-if="transferShow">
              <div id="loading">
                <div class="outer"></div>
                <div class="inner"></div>
              </div>
              <p>分析中</p>
            </div>
            <div class="analysis">
              <em>症状分词汇总</em>
              <div class="analysis-list">
                <span v-for="(item, index) in matchParticiple" :key="index">{{item}}</span>
              </div>
            </div>
          </div>
          <div class="pink-butt" v-if="!transferShow && !transferMesShow">
            <a href="javascript:void(0);" class="next" @click="netFour">选择认知算法</a>
            <a href="javascript:void(0);" @click="goTwo">返回修改</a>
          </div>
        </div>
        <!-- 步骤4 -->
        <div class="symp-w" v-if="showFour">
          <div class="symp-tit">请选择您进行认知诊断的算法</div>
          <div class="cal-wrap zclear">
            <div class="cal-cont">
              <span>您选择的表征</span>
              <p>{{typeName}}</p>
            </div>
            <div class="cal-cont">
              <span>您描述的症状信息</span>
              <p>{{desc}}</p>
            </div>
            <div class="cal-cont">
              <span>系统智能认知症状分词结果</span>
              <p><em v-for="(item, index) in matchParticiple" :key="index">{{item}}</em></p>
            </div>
            <div class="cal-cont">
              <span>认知诊断算法选择</span>
              <div class="cal-listwarp">
                <ul>
                  <li>
                    <div class="cal-list">
                      <i class="iconfont">&#xe637;</i>
                      <h3>正则模糊匹配算法</h3>
                      <a href="javascript:void(0)" @click="algorithm(1)" class="cal-butt">使用该算法</a>
                      <div class="mask">
                        <h3>正则模糊匹配算法</h3>
                        <p>正则模糊匹配是对字符串操作的一种逻辑公式,就是用事先定义好的一些特定字符、及这些特定字符的组合,组成一个“规则字符串”,这个“规则字符串”用来表达对字符串的一种过滤逻辑。</p>
                        <a href="javascript:void(0)" @click="algorithm(1)">使用该算法</a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="cal-list">
                      <i class="iconfont">&#xe639;</i>
                      <h3>K近邻分类算法</h3>
                      <a href="javascript:void(0)"  @click="algorithm(2)" class="cal-butt">使用该算法</a>
                      <div class="mask">
                        <h3>K近邻分类算法</h3>
                        <p> K近邻分类算法是最通俗易懂的机器学习算法之一,理论成熟,易于理解,对异常值不敏感,适合于多分类问题。</p>
                        <a href="javascript:void(0)"  @click="algorithm(2)">使用该算法</a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="cal-list">
                      <i class="iconfont">&#xe741;</i>
                      <h3>层次支持向量机(H-SVMs)</h3>
                      <a href="javascript:void(0)"  @click="algorithm(3)" class="cal-butt">使用该算法</a>
                      <div class="mask">
                        <h3>层次支持向量机(H-SVMs)</h3>
                        <p>是一种基于统计学习理论的机器学习方法, 较好地解决了非线性、高维数、局部极小点等问题,不仅能够保证分类精度,降低训练难度,同时提升了分类速度。</p>
                        <a href="javascript:void(0)"  @click="algorithm(3)">使用该算法</a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="cal-list">
                      <i class="iconfont">&#xe638;</i>
                      <h3>决策树Cart算法</h3>
                      <a href="javascript:void(0)"  @click="algorithm(4)" class="cal-butt">使用该算法</a>
                      <div class="mask">
                        <h3>决策树Cart算法</h3>
                        <p>决策树(Decision Tree）是在已知各种情况发生概率的基础上,通过构成决策树来求取净现值的期望值大于等于零的概率,评价项目风险,判断其可行性的决策分析方法,是直观运用概率分析的一种图解法。由于这种决策分支画成图形很像一棵树的枝干,故称决策树。在机器学习中,决策树是一个预测模型,他代表的是对象属性与对象值之间的一种映射关系。Entropy = 系统的凌乱程度,使用算法cart生成树算法使 用熵。</p>
                        <a href="javascript:void(0)"  @click="algorithm(4)">使用该算法</a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="cal-list">
                      <i class="iconfont">&#xe6c1;</i>
                      <h3>随机森林</h3>
                      <a href="javascript:void(0)"  @click="algorithm(5)" class="cal-butt">使用该算法</a>
                      <div class="mask">
                        <h3>随机森林</h3>
                        <p>随机森林是一个包含多个决策树的分类器, 并且其输出的类别是由个别树输出的类别的众数而定。 Leo Breiman和Adele Cutler发展出推论出随机森林的算法。 这个术语是1995年由贝尔实验室的Tin Kam Ho所提出的随机决策森林（random decision forests）而来的。这个方法则是结合 Breimans 的 "Bootstrap aggregating" 想法和 Ho 的"random subspace method"以建造决策树的集合</p>
                        <a href="javascript:void(0)"  @click="algorithm(5)">使用该算法</a>
                      </div>
                    </div>
                  </li>
                  <li>
                    <div class="cal-list">
                      <i class="iconfont">&#xe8ba;</i>
                      <h3>高斯朴素贝叶斯算法</h3>
                      <a href="javascript:void(0)"  @click="algorithm(6)" class="cal-butt">使用该算法</a>
                      <div class="mask">
                        <h3>高斯朴素贝叶斯算法</h3>
                        <p>高斯朴素贝叶斯算法作为机器学习算法中的经典算法之一,在处理多分类任务时,具有模型简单、分类速度快、分类效率高等优点,适合增量式训练。</p>
                        <a href="javascript:void(0)"  @click="algorithm(6)">使用该算法</a>
                      </div>
                    </div>
                  </li>
                </ul>
                <a href="javascript:void(0);" @click="goTwo">返回修改</a>
              </div>
            </div>
          </div>
        </div>
        <!-- 步骤5 -->
        <div class="symp-w" v-if="showFive">
          <div class="symp-tit rept-pad0">健康认知报告</div>
          <div class="rept-opt">表征<strong>{{typeName}}</strong></div>
          <div class="rept-wrap">
            <div class="rept-des">
              <em>症状自述</em>
              <div>{{desc}}</div>
            </div>
            <div class="rept-des">
              <em>症状信息摘取</em>
              <div><span v-for="(item, index) in matchParticiple" :key="index">{{item}}</span></div>
            </div>
            <div class="rept-des">
              <h5>疑似疾病分析</h5>
              <div>
               <pieChart ref="avgChartPie"></pieChart>
              </div>
              <div class="rept-doc" >
                <!-- tab -->
                <div class="rept-tab" style=" text-align: center;">
                  <ul style=" width:auto;display: inline-block;">
                    <li v-for="(item, index) in diseaseList" :key="index" @click="reportClick(item.disName)" style="float: left;height: auto;margin-right: 20px;">
                      <!-- <div class="rept-pct">{{item.pro}}</div> -->
                      <!-- <el-progress type="circle" :percentage="item.pro" ></el-progress> -->
                      <vm-progress type="circle" :width="80" :percentage="item.pro" :strokeColor="index == 0 ? '#ff625a' : index == 1 ? '#ff8a51' : index == 2 ? '#ffc017' : index == 3 ? '#23c685' : index == 4 ? '#29b2eb' : '#9575ff'"></vm-progress>
                      <p style="line-height:25px;height: auto; float: left; width: 100% ; line-height: 20px;font-size: 14px; text-align: center;margin-top: 16px;" :class="item.isTrue ? 'active' : 'initial'">{{item.disName.split('@')[1]}}</p>
                    </li>
                  </ul>
                </div>
                <!-- 疾病报告-->
                <div class="rept-content" v-if="fiveReport">
                  <div class="rept-content-a">
                    <div class="disease">{{diseaseName}}</div>
                    <p class="rept-article-tit" style="    line-height: 36px;" v-for="(item, index) in diseaseInfo" :key="index">
                      {{item.name}}:<br />
                      &#12288;&#12288;{{item.value}}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="rept-butt" v-if="fiveReport"><a href="javascript:void(0);" id="reptbtn" @click="diaOpen">更多维度报告分析</a></div>
          </div>
        </div>
      </div>
      <el-dialog visible.sync="false" width="444px" :show-close="false" style="line-height:1px;">
            <div class="codewrap">
              <img src="@/assets/images/weixin_coder.png">
              <p>扫码关注吾征AI公众号</p>
              <p>即可查看“更多维度分析报告”</p>
            </div>
            <div class="codewrap">
              <img src="@/assets/images/app_coder.png">
              <p>扫码下载吾征AI健康 APP</p>
              <p>医学生物特征认知专家</p>
            </div>
        <!-- 关注公众号 -->
        <div id="alertwarp">
          <div id="alertmask"></div>
          <div id="alertwx">
          </div>
        </div>
      </el-dialog>


<el-dialog :visible.sync="open" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">
      <img class='codewrapImg' src='@/assets/images/app_coder2.png' />
      <div class='codewrapdiv'>为了您更快捷全面的获取健康数据及更便捷的查看健康数据报告</div>
      <div class='codewrapdiv'>请您使用吾征AI健康APP或微信公众号体验健康服务</div>
      <div class='codewrapdiv2'>（扫描下方二维码下载安装APP或关注吾征AI微信公众号购买）</div>
      <div style='margin-bottom: 30px;'>
        <div class="codewrap">
          <img src="@/assets/images/app_coder.png">
          <p>吾征AI健康APP</p>
          <p>扫码下载</p>
        </div>
        <div class="codewrap">
          <img src="@/assets/images/weixin_coder.png">
          <p>吾征AI公众号</p>
          <p>扫码关注</p>
        </div>
      </div>
      <!-- 关注公众号 -->
      <div id="alertwarp">
        <div id="alertmask"></div>
        <div id="alertwx">
        </div>
      </div>
    </el-dialog>

    </div>
    <app-footer />
  </div>
</template>

<script>
import echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import { request } from '@/network/request'
import qs from 'qs'
import pieChart from '@/views/selfTest/PieChart'
import footer from '@/components/footer'
import Progress from 'vue-multiple-progress'
import header from '@/components/header'
export default {
  name: 'ica',
  components: {
    pieChart,
    'app-footer': footer,
    'vm-progress': Progress,
    'app-header': header,
  },
  data () {
    return {
      // 显示步骤
      showOne: true,
      showTwo: false,
      showThree: false,
      showFour: false,
      showFive: false,
      // 第五步报告
      fiveReport: false,
      // 第三部分析结果
      transferMesShow: true,
      // 第三步匹配分词结果
      transferShow: false,
      // 步骤
      isTwo: false,
      isThree: false,
      isFour: false,
      isFive: false,
      // 弹出框
      open: false,
      accessToScripts:[],
      // 自测类别
      selfTestTypeList: null,
      // 所选自测类别名称
      typeName: null,
      // 所选自测类别id
      typeId: null,
      txtVal: 0,
      // 第二部文本域内容
      desc: '',
      // 分词内容
      participle: null,
      // 分词汇总
      matchParticiple: null,
      // 分词汇总字符串以逗号分隔
      matchParticipleString: null,
      // 疑似疾病集合
      diseaseList: null,
      // 疾病详情
      diseaseInfo: null,
      diseaseName: null,
    }
  },
  created () {
    this.getSelfTestType();
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    leaveyou(val){
       this.desc = val;
       this.nextThree ();
    },
        huashu () {
             var _this = this;
             if(_this.desc!=''){


               request({
                    url: '/healthy/selfTest/accessToScripts',
                    method: 'get',
                    params: {
                        content: _this.desc,
                        systemId: _this.typeId
                        }
                  }).then(res => {
                    if (res.data.code == 200) {
                      _this.accessToScripts = res.data.data;
                    } else {
                    }
                  })
         }else{
          _this.accessToScripts = [];
         }
        },
    // 登录
    login () {
      this.$router.push('/login');
    },
    // 注册
    register () {
      this.$router.push('/register');
    },
    /** 获取自测类别 */
    getSelfTestType () {
      let _this = this;
      request({
        url: '/healthy/selfTest/getSelfTestType',
        method: 'get'
      }).then(res => {
        if (res.data.code == 200) {
          _this.selfTestTypeList = res.data.data;
        } else {
          alert('接口错误')
        }
      })
    },
    // 第二步
    nextTwo (item) {
      let _this = this;
      _this.typeId = item.systemId;
      _this.typeName = item.name;
      _this.showOne = false;
      _this.showTwo = true;
      _this.isTwo = true;
    },
    // 文本框字数限制
    descInput () {
      this.txtVal = this.desc.length;
      this.huashu ();
    },
    // 返回第一步
    go () {
      let _this = this;
      _this.showOne = true;
      _this.showTwo = false;
      _this.typeId = null;
      _this.typeName = null;
      _this.desc = null;
    },
    goTwo () {
      let _this = this;
      _this.showTwo = true;
      _this.showThree = false;
      _this.transferShow = true;
      _this.transferMesShow = true;
    },
    // 第三步
    nextThree () {

      let _this = this;
      if (_this.desc != "") {
        _this.isThree = true;
        _this.showTwo = false;
        _this.showThree = true;
        request({
          url: '/healthy/selfTest/participle',
          method: 'get',
          params: {
            "content": _this.desc,
            "systemId": _this.typeId
          }
        }).then(res => {
          if (res.data.code == 200) {
            setTimeout(() => {
              _this.participle = res.data.data;
              _this.matchParticipleMethod();
              _this.transferMesShow = false;
              //延迟时间：3秒
            }, 2000)
          } else {
            alert('分词接口错误');
          }
        })
      } else {
        alert('信息不能为空哦！')

      }
    },
    // 匹配分词
    matchParticipleMethod () {
      let _this = this;
      _this.transferShow = true;
      request({
        url: '/healthy/selfTest/matchParticiple',
        method: 'get',
        params: {
          "content": _this.desc,
          "systemId": _this.typeId
        }
      }).then(res => {
        if (res.data.code == 200) {
          setTimeout(() => {
            _this.matchParticiple = res.data.data;
            if (_this.matchParticiple != undefined) {
              _this.matchParticiple.forEach(res => {
                if (_this.matchParticipleString == null) {
                  _this.matchParticipleString = res
                } else {
                  _this.matchParticipleString = _this.matchParticipleString + ',' + res
                }
              });
              _this.transferShow = false;
            } else {
              alert("未匹配到分词，请重新输入！")
              _this.goTwo();
            }
            //延迟时间：3秒
          }, 2000);
        } else {
          alert('匹配分词接口错误');
        }
      })
    },
    // 第四步
    netFour () {
      let _this = this;
      _this.showThree = false;
      _this.showFour = true;
      _this.isFour = true;
    },
    // 算法（获取疾病-疾病分析过程）
    algorithm (id) {
      let _this = this;
      _this.showFour = false;
      _this.showFive = true;
      _this.isFive = true;
      request({
        url: '/healthy/selfTest/diseaseAnalysis',
        method: 'get',
        params: {
          "algorithm": id,
          "systemId": _this.typeId,
          "syms": this.matchParticipleString,
          "content": _this.desc,
        }
      }).then(res => {
        if (res.data.code == 200) {
          _this.diseaseList = res.data.data
          var data = [];
          var i = 0;
          var color = ['#10d1b4', '#00b2ee', '#00ce61', '#fad954', '#f08166', '#ac8bfc']
          res.data.data.forEach(element => {
            data[i] = { value: element.pro.split('%')[0], name: element.disName.split('@')[1], itemStyle: { normal: { color: color[i] } } }
            _this.diseaseList[i] = { 'disName': element.disName, 'pro': element.pro.split('%')[0], 'isTrue': i == 0 ? true : false }
            i++;
          });
          _this.reportClick(_this.diseaseList[0].disName);
          _this.diseaseName = _this.diseaseList[0].disName.split('@')[1];
          _this.$refs.avgChartPie.seriesData = [
            {
              name: '访问来源',
              type: 'pie',
              radius: '55%',
              center: ['50%', '50%'],
              data: data.sort(function (a, b) { return a.value - b.value; }),
              //roseType: 'radius',
              label: {
                color: '#000'
              },
              labelLine: {
                lineStyle: {
                  color: '#999'
                },
                smooth: 0.2,
                length: 10,
                length2: 20
              },
              itemStyle: {
                color: '#c23531',
                shadowBlur: 200,
                shadowColor: 'rgba(255, 255, 255, 0)'
              },

              animationType: 'scale',
              animationEasing: 'elasticOut',
              animationDelay: function (idx) {
                return Math.random() * 200;
              }
            }
          ]
          _this.$refs.avgChartPie.initChart();
        } else {
          alert("接口错误")
        }
      })
    },
    // 报告详情
    reportClick (disName) {
      let _this = this;
      _this.diseaseName = disName.split('@')[1];
      _this.diseaseList.forEach(element => {
        if (element.disName == disName) {
          element.isTrue = true;
        } else {
          element.isTrue = false;
        }
      });
      request({
        url: '/healthy/selfTest/getReport',
        method: 'get',
        params: {
          "systemId": _this.typeId,
          "dis": disName,
          "content": _this.desc,
          "reportType": "5"
        }
      }).then(res => {
        if (res.data.code == 200) {
          _this.diseaseInfo = res.data.data;
          _this.fiveReport = true;
        } else {
          alert("接口错误")
        }
      })
    },
    // 打开弹出框
    diaOpen () {
      let _this = this;
      _this.open = true;
    },
  }
}
</script>

<style scoped>
@import "../assets/css/all.css";
@import "../assets/css/pagestyle.css";
/* -----=====头部导航=====----- */
.nav-warp {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1600;
}
.nav-warp > div {
  width: 1200px;
  margin: 0 auto;
  height: 64px;
  position: relative;
}
.nav-warp .nav-logo {
  float: left;
  padding: 16px 0;
  position: absolute;
  left: 0;
  z-index: 2;
}
.nav-warp .nav-menu {
  width: 100%;
  position: absolute;
  padding: 16px 240px 16px 140px;
  text-align: center;
  z-index: 1;
}
.nav-warp .nav-menu a {
  padding: 0 20px;
  line-height: 30px;
  font-size: 16px;
  color: #fff;
  position: relative;
}
.nav-warp .nav-menu a:hover,
.nav-warp .nav-menu a.active {
  color: #14c86c;
}
.nav-warp .nav-signup {
  float: right;
  padding: 17px 0;
  position: absolute;
  right: 0;
  z-index: 2;
}
.nav-warp .nav-login a {
  float: left;
  width: 110px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  margin-left: 10px;
  font-size: 16px;
  color: #0ebf65;
  background: #fff;
  overflow: hidden;
  position: relative;
  z-index: 1;
  transition: all 0.2s;
}
.nav-warp .nav-login a:before {
  content: "";
  display: block;
  width: 200%;
  height: 100%;
  position: absolute;
  left: -100%;
  top: 0;
  z-index: -1;
  transform-origin: 0 0;
  transform: rotate(-90deg);
  transition: all 0.2s;
}
.nav-warp .nav-login a:nth-of-type(1) {
  color: #0ebf65;
  background: #fff;
}
.nav-warp .nav-login a:nth-of-type(1):hover {
  color: #fff;
}
.nav-warp .nav-login a:nth-of-type(1):before {
  background: #14c86c;
}
.nav-warp .nav-login a:nth-of-type(2) {
  color: #fff;
  background: #14c86c;
}
.nav-warp .nav-login a:nth-of-type(2):before {
  background: #fff;
}
.nav-warp .nav-login a:hover:nth-of-type(2) {
  color: #0ebf65;
}
.nav-warp .nav-login a:hover:before {
  transform: rotate(0deg);
}
.nav-warp .nav-signout {
  float: right;
  position: relative;
  z-index: 9;
}
.nav-warp .nav-signout a {
  float: left;
  background: none;
  margin-left: 30px;
  color: #fff;
  line-height: 30px;
  font-size: 14px;
}
.nav-warp .nav-signout a img {
  float: left;
  width: 30px;
  height: 30px;
  border-radius: 16px;
  -moz-border-radius: 16px;
  -webkit-border-radius: 16px;
  overflow: hidden;
  margin-right: 10px;
}
.nav-warp .nav-signout a i {
  float: left;
  margin-top: 7px;
  margin-right: 10px;
  width: 16px;
  height: 16px;
  background: url(../assets/img/out_icon.png) no-repeat center;
}
.nav-warp .nav-signout a:hover {
  color: #14c86c;
}

.ica {
  background: #262728;
}
.tophaeader .header-1-nav > a {
  color: #fff;
}
.ica .header-1-nav > a:hover,
.tophaeader .header-1-nav > a:hover {
  color: #14c86c;
}
.min {
  width: 100%;
  margin: 0 auto;
  height: 1500px;
}
.active {
  color: #000;
}
.initial {
  color: #c6c7ca;
}
.codewrap {
  display: inline-block;
  width: 100px;
  margin-right: 70px;
  margin-left: 70px;
  text-align: center;
}
.codewrap img {
  padding-bottom: 10px;
}
.codewrap p {
  width: 100%;
  height: 22px;
  line-height: 22px;
}

/* 话述提示 */
.input-tips {
  width: 680px;
  border: 1px solid #eee;
  background: #fff;
  float: left;
  margin-top: 4px;
}
.input-tips p {
  width: 100%;
  font-weight: 700;
  font-size: 14px;
  padding: 15px 10px;
  border-bottom: 1px solid #eee;
}
.tips_wrap {
  width: 100%;
  max-height: 230px;
  overflow-y: auto;
}
.input-tips ul {
}
.input-tips ul li {
  font-size: 14px;
  color: #666;
  padding: 15px 10px;
}
.input-tips ul li:hover {
  background: #f5f5f5;
  color: #000;
}


.codewrapImg {

  width: 128px;
  height: 128px;
  margin-bottom: 50px;
  margin-top: 30px;
}

.codewrapdiv {
  height: 15px;
  color: #000000;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
}

.codewrapdiv2 {
  height: 15px;
  color: #666;
  font-size: 15px;
  font-weight: 400;
  margin-bottom: 45px;
}

.codewrap {
  display: inline-block;
  width: 100px;
  margin-right: 70px;
  margin-left: 70px;
  text-align: center;
}

.codewrap img {
  padding-bottom: 10px;
  margin-top: 40px;
}

.codewrap p {
  width: 100%;
  height: 22px;
  line-height: 22px;
  margin-bottom: 20px;
}

</style>



// WEBPACK FOOTER //
// src/views/ica.vue